import { ReactNode } from 'react';

// Ícones em SVG (estilo linha) — profissionais, tema manutenção/facilities.
const PATHS: Record<string, ReactNode> = {
  // chave de boca (manutenção)
  chave: <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />,
  // balão de conversa (WhatsApp/aviso)
  chat: <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />,
  // QR code (ativos)
  qr: <><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><path d="M14 14h3v3M21 14v.01M14 21h.01M21 21v-3" /></>,
  // checklist
  checklist: <><path d="M9 11l2 2 4-4" /><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 9h3M3 14h3" /></>,
  // PMOC / climatizacao
  pmoc: <><circle cx="12" cy="12" r="3" /><path d="M12 2v4M12 18v4M2 12h4M18 12h4M4.9 4.9l2.8 2.8M16.3 16.3l2.8 2.8M19.1 4.9l-2.8 2.8M7.7 16.3l-2.8 2.8" /></>,
  // caixa (estoque)
  caixa: <><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><path d="M3.3 7 12 12l8.7-5M12 22V12" /></>,
  // gráfico (dashboard)
  grafico: <><path d="M3 3v18h18" /><rect x="7" y="11" width="3" height="6" rx="1" /><rect x="12" y="7" width="3" height="10" rx="1" /><rect x="17" y="13" width="3" height="4" rx="1" /></>,
  // prancheta (abrir chamado)
  prancheta: <><path d="M9 4h6a1 1 0 0 1 1 1v1H8V5a1 1 0 0 1 1-1z" /><path d="M16 5h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2" /><path d="M8 11h8M8 15h5" /></>,
  // calendário (agendamento)
  calendario: <><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></>,
  // técnico (atribuir)
  tecnico: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M16 11l2 2 4-4" /></>,
  mapa: <><path d="M9 18 3 21V6l6-3 6 3 6-3v15l-6 3-6-3z" /><path d="M9 3v15M15 6v15" /><circle cx="12" cy="11" r="2" /></>,
  // engrenagem
  engrenagem: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></>,
  // relógio (tempo)
  relogio: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  // raio (rápido)
  raio: <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />,
  // prédio (unidade)
  predio: <><rect x="4" y="3" width="16" height="18" rx="1" /><path d="M9 7h.01M15 7h.01M9 11h.01M15 11h.01M9 15h.01M15 15h.01M10 21v-3h4v3" /></>,
  // email
  email: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></>,
  // cadeado (senha)
  cadeado: <><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></>,
  // usuário
  usuario: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
  // vídeo (gravação na OS)
  video: <><rect x="3" y="6" width="13" height="12" rx="2" /><path d="m16 10 5-3v10l-5-3z" /></>,
  // câmera / foto (evidência na OS)
  foto: <><path d="M4 8a2 2 0 0 1 2-2h1.5l1-1.5h5l1 1.5H18a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" /><circle cx="12" cy="12.5" r="3.2" /></>,
  // pino de localização (rastreamento em tempo real)
  local: <><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z" /><circle cx="12" cy="10" r="2.5" /></>,

  // cartão de pagamento (integrações financeiras)
  cartao: <><rect x="2" y="5" width="20" height="14" rx="2.5" /><path d="M2 10h20M6 15h4" /></>,
  // celular (app mobile / download)
  celular: <><rect x="6" y="2" width="12" height="20" rx="2.5" /><path d="M11 18h2" /></>,
};

export default function Icone({ nome, size = 24 }: { nome: string; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {PATHS[nome] || null}
    </svg>
  );
}

// Selo do Instagram (quadrado degradê + câmera branca) — mesmo estilo do ícone
// oficial do app, pra ficar reconhecível em qualquer fundo.
export function IconeInstagram({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
      <defs>
        <linearGradient id="ig-grad" x1="0" y1="40" x2="40" y2="0">
          <stop offset="0" stopColor="#FED576" />
          <stop offset=".26" stopColor="#F47133" />
          <stop offset=".61" stopColor="#BC3081" />
          <stop offset="1" stopColor="#4C63D2" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="11" fill="url(#ig-grad)" />
      <path fill="#fff" d="M20 11.6c2.46 0 2.75.01 3.72.05 2.5.12 3.67 1.3 3.79 3.79.04.97.05 1.26.05 3.72s-.01 2.75-.05 3.72c-.12 2.48-1.28 3.67-3.79 3.79-.97.04-1.26.05-3.72.05s-2.75-.01-3.72-.05c-2.51-.12-3.67-1.31-3.79-3.79-.04-.97-.05-1.26-.05-3.72s.01-2.75.05-3.72c.12-2.49 1.28-3.67 3.79-3.79.97-.04 1.26-.05 3.72-.05M20 10c-2.5 0-2.81.01-3.79.06-3.34.15-5.2 2-5.35 5.35-.05.98-.06 1.29-.06 3.79s.01 2.81.06 3.79c.15 3.34 2 5.2 5.35 5.35.98.05 1.29.06 3.79.06s2.81-.01 3.79-.06c3.34-.15 5.2-2 5.35-5.35.05-.98.06-1.29.06-3.79s-.01-2.81-.06-3.79c-.15-3.34-2-5.2-5.35-5.35-.98-.05-1.29-.06-3.79-.06m0 4.32a5.68 5.68 0 1 0 0 11.36 5.68 5.68 0 0 0 0-11.36m0 9.37a3.69 3.69 0 1 1 0-7.38 3.69 3.69 0 0 1 0 7.38m5.9-9.6a1.33 1.33 0 1 1-2.65 0 1.33 1.33 0 0 1 2.65 0" />
    </svg>
  );
}

// Logo colorido da Play Store (triângulo 4 cores) — ícone de marca, não segue o
// padrão de linha/stroke dos demais (precisa de fill por segmento).
export function IconePlayStore({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size * 129.2 / 120.9} viewBox="30 336.7 120.9 129.2" aria-hidden="true">
      <path fill="#FFD400" d="M119.2,421.2c15.3-8.4,27-14.8,28-15.3c3.2-1.7,6.5-6.2,0-9.7c-2.1-1.1-13.4-7.3-28-15.3l-20.1,20.2L119.2,421.2z" />
      <path fill="#FF3333" d="M99.1,401.1l-64.2,64.7c1.5,0.2,3.2-0.2,5.2-1.3c4.2-2.3,48.8-26.7,79.1-43.3L99.1,401.1L99.1,401.1z" />
      <path fill="#48FF48" d="M99.1,401.1l20.1-20.2c0,0-74.6-40.7-79.1-43.1c-1.7-1-3.6-1.3-5.3-1L99.1,401.1z" />
      <path fill="#3BCCFF" d="M99.1,401.1l-64.3-64.3c-2.6,0.6-4.8,2.9-4.8,7.6c0,7.5,0,107.5,0,113.8c0,4.3,1.7,7.4,4.9,7.7L99.1,401.1z" />
    </svg>
  );
}
